import React, { createContext, useContext, useEffect, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import { config } from '../config/env';

interface MapsContextType {
  isLoaded: boolean;
  error: string | null;
}

const MapsContext = createContext<MapsContextType>({ isLoaded: false, error: null });

export function MapsProvider({ children }: { children: React.ReactNode }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: config.googleMapsApiKey,
      version: 'weekly',
      libraries: ['places']
    });

    loader.load()
      .then(() => setIsLoaded(true))
      .catch((err) => {
        console.error('Maps loading error:', err);
        setError('Failed to load map. Please try again later.');
      });
  }, []);

  return (
    <MapsContext.Provider value={{ isLoaded, error }}>
      {children}
    </MapsContext.Provider>
  );
}

export const useMaps = () => useContext(MapsContext);